var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Biolgy",
    transform: "translate(21463 -1955)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4659",
    "data-name": "Rectangle 4659",
    width: 89,
    height: 89,
    rx: 10,
    transform: "translate(-21463 1955)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_25",
    "data-name": "Union 25",
    d: "M7.871,50.29a1.485,1.485,0,0,1,0-2.97H10.4V43.865q-.555-.185-1.1-.415a15.234,15.234,0,0,1-.523-27.821,4.749,4.749,0,0,1,4.19-4.368l-1.257-2.7A3.417,3.417,0,0,1,14.8,3.706a3.428,3.428,0,0,1,3.1,1.973L23.738,18.2a3.39,3.39,0,0,1,.114,2.612,3.449,3.449,0,0,1-.2.448,1.194,1.194,0,0,0-.617-.172,1.17,1.17,0,0,0-.5.112l-2.019.941a1.176,1.176,0,0,0-.659.824v0h0a3.45,3.45,0,0,1-2.309-1.879l-.767-1.646a4.75,4.75,0,0,1-6.623-.095c-.093-.093-.18-.188-.265-.286A11.658,11.658,0,1,0,26,33.879H17.6a1.337,1.337,0,1,1,0-2.673H31.709a1.337,1.337,0,0,1,0,2.673H29.785a15.261,15.261,0,0,1-8.636,9.572q-.4.167-.8.312V47.32h2.524a1.485,1.485,0,1,1,0,2.97Zm7.8-45.482a.6.6,0,0,0-.287.79l6.591,14.133a.594.594,0,1,0,1.076-.5L16.464,5.1a.593.593,0,0,0-.789-.288ZM10.4,15.983a3.119,3.119,0,1,0,3.119-3.119A3.123,3.123,0,0,0,10.4,15.983Zm9.663,7.989L20,23.852l4.173-1.946.056.122a1.5,1.5,0,0,1-.725,1.993l-1.454.679a1.5,1.5,0,0,1-1.993-.726Zm1.724-1.115.608-.283c-.106.062-.209.116-.306.161s-.2.087-.3.123ZM10.217,3.413A1.411,1.411,0,0,1,10.9,1.537L12.784.659a1.411,1.411,0,0,1,1.193,2.558L12.092,4.1a1.41,1.41,0,0,1-1.875-.682Z",
    transform: "translate(-21434.521 1974.166)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiology);
export default __webpack_public_path__ + "static/media/Biology.de8f54e8.svg";
export { ForwardRef as ReactComponent };